import script from "./currencyWallet.vue?vue&type=script&setup=true&lang=js"
export * from "./currencyWallet.vue?vue&type=script&setup=true&lang=js"

import "./currencyWallet.vue?vue&type=style&index=0&id=a056dd4c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a056dd4c"]])

export default __exports__